
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { Alert, ApiGateway } from 'cw-backend';
import { SnackBarService } from 'cw-utils';

@Injectable()
export class AlertEditProvider implements Resolve<any>
{
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    alert: Alert;

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise((resolve, reject) => {
            Promise.all([this.getAlert()]).then(
                () => {
                    resolve(true);
                },
                reject
            );
        });
    }

    getAlert(): Promise<any> {
        return new Promise((resolve, reject) => {
            let data =  this.checkLastModifications()
            if (data && data.id == this.routeParams.id) {
                this.alert = data;
                this.onDataChanged.next(this.alert);
                resolve(this.alert);
            } else if (this.routeParams.id === 'novo') {
                this.onDataChanged.next(false);
                resolve(false);
            }
            else {
                this.gw.get('alert/' + this.routeParams.id).subscribe({next:(res: Alert ) => {
                    this.alert = res;
                    this.onDataChanged.next(this.alert);
                    resolve(res);
                }, error: (err: any) => { reject(err) }});
            }
        });
    }

    insert(alert): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('alert/', alert).subscribe({next:(response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, error: (err: any) => { reject(err) }});
        });
    }

    edit(alert): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('alert/', alert).subscribe({next:(response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, error: (err: any) => { reject(err) }});
        });
    }

    delete(alert): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('alert/' + alert.id).subscribe({next:(response: HttpResponse<any>) => {
                resolve(response);
                 this.snackBar.successMessage(response.body.message);
            }, error: (err: any) => { reject(err) }});
        });
    }

    checkLastModifications(): Alert {
        let wasLocked = JSON.parse(localStorage.getItem('session_locked'));
        let data;
        if (wasLocked){
            data = JSON.parse(localStorage.getItem('last_modification'));
            localStorage.removeItem('session_locked');
        }  
        return data;
    }
}
